module.exports = __webpack_public_path__ + "static/media/Ba.0eeb5ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Achievements/Ba.png
// module id = 351
// module chunks = 0